import styled from 'styled-components';

import { Grid, Paper, TextField } from '@mui/material';
import { InputAdornment } from '@mui/material';

export const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1.5rem 0;

    width: 100%;
    height: 5rem;
`;

export const GraphicContainer = styled(Paper)`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 24px;
    gap: 24px;

    width: 100%;
    height: 266px;

    background: #ffffff;
    box-shadow: 0px 3px 12px rgba(81, 69, 159, 0.08);
    border-radius: 15px;

    flex: none;
    order: 0;
    flex-grow: 0;

    > h1 {
        height: 29px;

        font-family: 'Myriad Pro';
        font-style: normal;
        font-weight: 700;
        font-size: 24px;
        line-height: 29px;

        display: flex;
        align-items: center;

        color: #25272e;

        flex: none;
        order: 0;
        align-self: stretch;
        flex-grow: 0;
    }
`;

export const GraphicContainerColumn = styled.div`
    display: flex;
    flex-direction: column;
    padding: 24px;
    gap: 24px;

    width: 100%;
    height: 678px;
    /* Card */
    overflow-y: auto;

    > h1 {
        height: 29px;

        font-family: 'Myriad Pro';
        font-style: normal;
        font-weight: 700;
        font-size: 24px;
        line-height: 29px;

        display: flex;

        color: #25272e;

        flex: none;
        order: 0;
        align-self: stretch;
        flex-grow: 0;
    }
`;

export const GraphicContainerRow = styled(Paper)`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding: 24px;
    gap: 24px;

    width: 100%;
    height: 396px;

    background: #ffffff;
    box-shadow: 0px 3px 12px rgba(81, 69, 159, 0.08);
    border-radius: 15px;

    > h1 {
        height: 29px;

        font-family: 'Myriad Pro';
        font-style: normal;
        font-weight: 700;
        font-size: 24px;
        line-height: 29px;

        display: flex;
        align-items: center;

        color: #25272e;

        flex: none;
        order: 0;
        align-self: stretch;
        flex-grow: 0;
    }
`;
export const Elipse = styled.span`
    height: 20px;
    width: 20px;
    padding: 5px;
    text-align: center;
    border-radius: 50%;
    display: inline-block;
    color: #fff;
    font-size: 1.1em;
    font-weight: 600;
    background-color: rgba(0, 0, 0, 0);
    border: 6px solid ${(props) => (props.color ? props.color : '#b8d873')};
`;

export const Line = styled.div`
    margin: 5px 0;
    height: 2px;
    width: 100.99px;
    border-bottom: 2px dotted #fff;
    background: ${(props) =>
        `linear-gradient(#fff 0 0) padding-box, linear-gradient(to right, ${props.start ?? '#FFF'}, ${props.end ?? '#FFF'}) border-box`};
`;

export const ContainerRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 24px;
    width: 100%;
    border-radius: 15px;
    flex: none;
    order: 0;
    flex-grow: 0;
    > p {
        width: 100.84px;
        height: 38px;
        font-family: 'Myriad Pro';
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 19px;
        text-align: right;
        color: #9ba1a9;
    }
`;

export const CInputAdornment = styled(InputAdornment)`
    width: 115px;
    color: #9ba1a9;
`;

export const SearchBox = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 20px;

    @media (max-width: 768px) {
        flex-direction: column;
    }

    background-color: #f0f1f3;
    padding: 1rem;
    border-radius: 12px;
    margin-bottom: 1rem;
`;

export const TextFildStyled = styled(TextField)`
    width: 50%;

    @media (max-width: 768px) {
        width: 100%;
    }

    background-color: white;
`;

export const Div = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;

    @media (max-width: 768px) {
        align-items: flex-start;
        flex-direction: column;
        justify-content: flex-start;
    }

    > strong {
        margin-right: 1rem;
    }
`;

export const DivAlert = styled(Grid)`
    background-color: rgba(255, 0, 0, 0.07);
    padding: 1rem;
    border-radius: 12px;
    width: 100%;
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const DivSearch = styled.div`
    width: 100%;
`;

export const DivNumProperty = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;

    @media (max-width: 768px) {
        justify-content: flex-start;
    }

    gap: 20px;
    width: 100%;
    /* > p {
        font-family: 'Myriad Pro';
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        text-align: center;
    } */

    .properties-count {
        font-family: 'Myriad Pro';
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        text-align: center;

        display: flex;
        align-items: center;
        justify-content: center;
        gap: 5px;

        @media (max-width: 768px) {
            flex-direction: column;
        }
    }
`;
